// deployment_class: customer_env_allowed
/**
 * PortalNotAccessible — friendly explainer page rendered by RequireScope when
 * a user lacks the required scope. Per Spec 12 §5.2 + §6.5, this is NOT a
 * generic 403; it explains WHICH scope is missing and offers a path back to
 * a portal the user can access (Marketplace browse is always public).
 */
import { Link } from 'react-router-dom';

const SCOPE_DESCRIPTIONS: Record<string, string> = {
  'analytics.read': 'the Data Analytics portal',
  'analytics.write': 'editing Data Analytics dashboards',
  'sales.read': 'the Sales portal',
  'sales.write': 'editing Sales pipeline records',
  'admin.read': 'platform administration views',
  'admin.write': 'platform administration controls',
};

export function PortalNotAccessible({ scope }: { scope: string }): JSX.Element {
  const description = SCOPE_DESCRIPTIONS[scope] ?? `the "${scope}" capability`;
  return (
    <div className="min-h-screen bg-paper text-ink p-page">
      <div className="max-w-prose">
        <p className="font-body text-label uppercase text-warm-gray-d">Access</p>
        <h1 className="font-display text-display-1 mt-2">
          You don&rsquo;t have access to this portal.
        </h1>
        <p className="mt-rhythm text-body-l text-warm-gray-d">
          Your current account doesn&rsquo;t include {description}. If you
          believe this is a mistake, contact your organization&rsquo;s admin or{' '}
          <a
            href="mailto:support@kathedral.ai"
            className="text-trust underline underline-offset-2"
          >
            support@kathedral.ai
          </a>
          .
        </p>
        <p className="mt-rhythm text-body-s text-warm-gray-d">
          Required scope: <code className="bg-paper-soft px-1 py-0.5">{scope}</code>
        </p>
        <Link
          to="/marketplace"
          className="mt-rhythm inline-block text-trust underline underline-offset-2"
        >
          Browse the Marketplace
        </Link>
      </div>
    </div>
  );
}
